import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StudentService } from 'src/app/services/Student/student.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { FinanceService } from 'src/app/services/Finance/finance.service';
import * as moment  from 'moment';

@Component({
  selector: 'app-student-tccount-report',
  templateUrl: './student-tccount-report.component.html',
  styleUrls: ['./student-tccount-report.component.css']
})
export class StudentTCCountReportComponent implements OnInit {

  constructor(private financeService:FinanceService,private studentService:StudentService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }



 ReportModel = {
    AssessmentSetupID: 0,
    ClassID: 0,
    AssessmentTermID: 0,
    AssessmentAreaID: 0,
    AssessmentAcademicID: 0,
    SectionID: 0,
    StreamID: 0,
    CourseID: 0,
    SessionID: 0,
    FromDate: moment(new Date(Date.now())).format('DD-MMM-YYYY') ,
    ToDate: moment(new Date(Date.now())).format('DD-MMM-YYYY'),
    Print:""
};
SectionList:any;
ClassList :any;
ClassGroupList :any;
StudentSumSectionList =[];
SectionL:any;
StudentSumTotal=0;
GetStudentTCCountReport () {    
  this.ReportModel.ToDate=moment(this.ReportModel.ToDate).format('DD-MMM-YYYY');
  this.ReportModel.FromDate=moment(this.ReportModel.FromDate).format('DD-MMM-YYYY');
  this.spinnerService.show();
    this.studentService.GetStudentTCCountReport(JSON.stringify(this.ReportModel)).subscribe( (data) =>{
        this.SectionList = data.SectionList;
        this.ClassList = data.ClassList;
        this.ClassGroupList = data.ClassGroupList;
        this.spinnerService.hide();
        this.SectionL = this.SectionList.length;
        if(data.StudentSumSectionList.length>0){
          this.StudentSumSectionList = data.StudentSumSectionList;
        this.StudentSumTotal=this.StudentSumSectionList[0].StudentSumTotal;
        }
        
    });

};
loadingXLS = false;
FilePath:any;
XLSDownload () {
    this.loadingXLS = true;
    this.ReportModel.Print = 'XLS';
    this.ReportModel.ToDate=moment(this.ReportModel.ToDate).format('DD-MMM-YYYY');
  this.ReportModel.FromDate=moment(this.ReportModel.FromDate).format('DD-MMM-YYYY');
    this.studentService.GetStudentTCCountReport(JSON.stringify(this.ReportModel)).subscribe( (data)=> {


        this.FilePath = data.FilePath;
        window.location = data.FilePath;



      
    });

};
Print () {

    // window.print();

    var divContents = document.getElementById("dvContainer").innerHTML;
    divContents = divContents.replace('no record found', '');
    var printWindow = window.open('', '', 'height=400,width=800');
    printWindow.document.write('<html><head><title>Student Marks Summary</title>');
    printWindow.document.write('<style type="text/css">');
    printWindow.document.write('.t1{ border-top: 1px solid black;  border-left: 1px solid black;white-space:nowrap;font-family:Calibri;font-size:10px} .t2 { border-right: 1px solid black; border-bottom: 1px solid black;}.t3 { border-right: 1px solid black;border-bottom: 1px solid black; }');
    printWindow.document.write('</style>');
    printWindow.document.write('</head><body >');
    printWindow.document.write(divContents);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
}
AcademicSessionList:any;
GetAcademicSession () {


    this.lookupService.GetLookupsList('AcademicSession', '').subscribe( (data) =>{
        this.AcademicSessionList = data.LookupItems;
    });
};


  ngOnInit() {
    this.GetStudentTCCountReport();
    this.GetAcademicSession();
  }

}
